import '../../css/FilterControllers.css'

import { useSelector, useDispatch } from 'react-redux';

import { updateUserSetting } from '../../features/counter/eqFiltersReducer';
import ManualController from '../ManualController';

const FilterControllers = () => {
    const filters = useSelector((state) => state.filters.userSetting);
    const dispatch = useDispatch();

    // Handle updates to the filter
    const handleUpdate = (index, key, value) => {
        console.log('filter updated:', key, value)
        dispatch(
            updateUserSetting({
                index,
                key,
                value,
            })
        );
    };

    if (!filters || !Array.isArray(filters)) {
        return (
            <div className="filter-controllers">
                <div className="empty-state">
                    <p>No filters available. Use the "Resume Filters" button to restore them.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="filter-controllers">
            {filters.map((filter, index) => (
                <div key={index} className="manual-controller-wrapper">
                    <ManualController filter={filter} index={index} handleUpdate={handleUpdate}/>
                </div>
            ))}
        </div>
    );
}

export default FilterControllers